// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"518":"Medidas","968":"Selector"}[chunkId] + "." + {"518":"32e6f9da","968":"96ce1f58"}[chunkId] + ".css";
};